import React from "react";
import SaasProductWizard from "../index";

function BackupNowWizard() {
  return <SaasProductWizard productType="backup-now" />;
}

export default BackupNowWizard;